import { Tooltip } from "primereact/tooltip";
import { CSSProperties } from "react";




function createFlatIconButtonId(): string {
    const id = Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000;
    return `fbx-flat-icon-button-${id}`;
}

export interface FlatIconButtonProps {
    onClick?: (e: any) => void;
    icon?: string;
    imageUrl?: string;
    className?: string;
    caption?: string;
    style?: CSSProperties;
    id?: string;
    disable?: boolean;
    testId?: string;
    description?: string;
}


/**
 * Renders a flat icon-based button tile with optional caption or image.
 * @param props - Visual parameters and click handler configuration for the tile.
 * @returns A styled button element respecting disabled state and custom layout.
 */
export function FlatIconButton(props: FlatIconButtonProps) {

    //const generatedIdRef = useRef<string>(props.id || createFlatIconButtonId());
    const randomId = createFlatIconButtonId();
    const buttonId = props.id || randomId;

    return (

        <div id={buttonId} data-testid={props.testId} className={`fbx-icon-button ${props.disable ? "fbx-icon-button-disabled" : ""} ${props.className}`} style={props.style} onClick={props.disable ? undefined : props.onClick}>
            <div className="fbx-icon-button-contents fbx-center">
                {props.caption ?
                    <div className="fbx-icon-button-caption fbx-center">
                        {props.caption}
                    </div> : undefined}
                {props.icon ?
                    <div className={`${props.icon} fbx-icon-button-icon fbx-center`} />
                    : undefined}
                {props.imageUrl ?
                    <div className="flex justify-content-center">
                        <img src={props.imageUrl} className="fbx-icon-button-image fbx-center flex" />
                    </div>
                    : undefined}
                {/* {props.description ?
                    <div className="fbx-icon-button-description fbx-center">
                        {props.description}
                    </div> : undefined} */}
            </div>
            <Tooltip target={`#${buttonId}`} content={props.description} />
        </div>
    )
}